/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";
import {
  useGetCarteiraClientes
} from "~/pages/Wallet/hooks/useWallet";
import { useLiveQuery } from "dexie-react-hooks";
import { liveQuery } from "dexie";
import { validarProspectsConvertidos } from "~services/utils/validarProspectsConvertidos";
import { db } from "~/db/db";
import useParametros from "~/fetchs/useParametros";
import useVendedor from "~/fetchs/useVendedor";
import useWorker from "~hooks/useWorker";

const initial_clientes = 100;
const background_clientes = 1000;
const remote_scroll_clientes = 100;

const hasFilterValue = (value) => value !== null && value !== 0 && value !== undefined && value !== "";

const appendClientes = (previousClientes = [], nextClientes = []) => {
  const previousIds = new Set(previousClientes.map((cliente) => cliente.id));
  const novosClientes = nextClientes.filter((cliente) => !previousIds.has(cliente.id));
  return [...previousClientes, ...novosClientes];
};

const scheduleBackgroundTask = (callback) => {
  if (typeof globalThis !== "undefined" && typeof globalThis.requestIdleCallback === "function") {
    return globalThis.requestIdleCallback(callback);
  }

  return globalThis.setTimeout(callback, 150);
};

const cancelBackgroundTask = (taskId) => {
  if (typeof globalThis !== "undefined" && typeof globalThis.cancelIdleCallback === "function") {
    globalThis.cancelIdleCallback(taskId);
    return;
  }

  globalThis.clearTimeout(taskId);
};

const tiposComCacheListagem = ["carteira", "recebedor"];
const cacheListagem = {};

const useClientes = ({ formikRef, type, campo, microrregiao = 0, restartFetch = true, skip, take = 6, setLoadingSearch = () => { }, idCliente, enabledRequest = true, clientesDisponiveis, filters, bloqueadoStatus = 0,  }) => {

  const [searchTerm, setSearchTerm] = useState(() => {
    const pathname = globalThis.location.pathname;
    const key = `${pathname}-listagem`;
    return globalThis.localStorage.getItem(key) || "";
  });
  const [cacheInicial] = useState(() => {
    const cache = tiposComCacheListagem.includes(type) ? cacheListagem[type] : null;
    return cache && cache.searchTerm === searchTerm ? cache : null;
  });
  const [clientes, setClientes] = useState(() => cacheInicial?.clientes ?? []);
  const clienteSelect = useSelect("cliente");
  const [total, setTotal] = useState(() => cacheInicial?.total ?? 0);
  const [takeCarteira, setTakeCarteira] = useState(initial_clientes);
  const [skipCarteira, setSkipCarteira] = useState(0);
  const [remotePageSkip, setRemotePageSkip] = useState(0);
  const [remoteBufferedClientes, setRemoteBufferedClientes] = useState([]);
  const [todosOsClientes, setTodosOsClientes] = useState([]);

  const hasActiveFilters = Boolean(
    searchTerm ||
    hasFilterValue(filters?.segmentoId) ||
    hasFilterValue(filters?.trilhaId) ||
    hasFilterValue(filters?.microrregiao) ||
    hasFilterValue(filters?.cidadeId) ||
    hasFilterValue(filters?.tipo) ||
    hasFilterValue(filters?.bloqueado)
  );
  const shouldUseRemotePagination = false;

  const { vendedorSelecionado, vendedorId, isVendedorReady } = useVendedor();
  const vendedorSelecionadoNormalizado = vendedorSelecionado !== undefined
    ? (vendedorSelecionado ?? null)
    : (localStorage.getItem("vendedor-selecionado-id") || null);
  const shouldWaitForVendedor = false;
  const queryStateKey = useMemo(
    () => JSON.stringify({
      type,
      searchTerm,
      microrregiao,
      idCliente,
      vendedorSelecionado: vendedorSelecionadoNormalizado,
      filters: Object.fromEntries(Object.entries(filters || {}).filter(([, value]) => hasFilterValue(value))),
      clientesDisponiveis: clientesDisponiveis || null,
    }),
    [type, searchTerm, microrregiao, idCliente, vendedorSelecionadoNormalizado, filters, clientesDisponiveis]
  );

  const lastQueryStateKeyRef = useRef(cacheInicial?.queryStateKey ?? null);
  const appliedQueryStateKeyRef = useRef(null);
  const activeFetchIdRef = useRef(0);
  const [appliedQueryStateKey, setAppliedQueryStateKey] = useState(null);
  const isQueryPending = appliedQueryStateKey !== queryStateKey;

  const markQueryApplied = () => {
    appliedQueryStateKeyRef.current = queryStateKey;
    setAppliedQueryStateKey(queryStateKey);
  };

  useEffect(() => {
    if (!tiposComCacheListagem.includes(type) || isQueryPending) return;
    cacheListagem[type] = { searchTerm, clientes, total, queryStateKey };
  }, [type, isQueryPending, searchTerm, clientes, total, queryStateKey]);

  useEffect(() => {
    if (appliedQueryStateKeyRef.current !== queryStateKey) {
      activeFetchIdRef.current += 1;
    }
  }, [queryStateKey]);


  // useEffect(() => {
  //   setClientes([]);
  //   setTotal(0);
  //   if (filters) {
  //     filters.segmentoId = undefined;
  //     filters.trilhaId = undefined;
  //     filters.cidadeId = undefined;
  //     filters.tipo = undefined;
  //     filters.bloqueado = undefined;
  //     filters.microrregiao = undefined;
  //   }
  // }, [vendedorSelecionado]);


  const clientesCarteira = useGetCarteiraClientes(takeCarteira, skipCarteira, enabledRequest && isVendedorReady, vendedorId);
  const clientesCarteiraPaginada = useGetCarteiraClientes(remote_scroll_clientes, remotePageSkip, false, vendedorId);
  const { save: saveClientesWorker, remove: removeClientesWorker } = useWorker({ table: "cliente" });

  const { getBotoesCliente, parametros } = useParametros();

  const arrayOptionsCliente = ["codigo", "razaoSocial", "documento"];
  const arrayOptionsProspect = ["codigoProspect", "razaoSocial", "documento"];
  const arrayOptionsSimulador = ["codigoGeral", "razaoSocial", "documento"];
const initialized = true;


useEffect(() => {
  if (searchTerm.length > 1) {
    const pathname = globalThis.location.pathname;
    const key = `${pathname}-listagem`;
    globalThis.localStorage.setItem(key, searchTerm);
  }
}, [searchTerm]);


  useEffect(() => {
    const pathname = globalThis.location.pathname;
    const key = `${pathname}-listagem`;
    const storedSearchTerm = globalThis.localStorage.getItem(key);
    if (pathname.includes("-listagem") && !storedSearchTerm) {
      setSearchTerm("");
    }
  }, []);





  const normalizeString = (str) =>
    str
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f\s]/g, "")
      .replace(/[./-]/g, "");

  const searchProspect = (cliente) => {
    return [
      (cliente.nome ?? "").toLowerCase(),
      (cliente.segmento ?? "").toLowerCase(),
      (cliente.microrregiao ?? "").toLowerCase(),
      (cliente.grupoCentralizador ?? "").toLowerCase(),
      (cliente.documento ?? "").toLowerCase(),
      (cliente.codigoProspect ?? "").toLowerCase(),
    ].some((str) => normalizeString(str).includes(normalizeString(searchTerm.toLowerCase())));
  };

  const searchRecebedor = (cliente) => {
    return [
      (cliente.nome ?? "").toLowerCase(),
      (cliente.segmento ?? "").toLowerCase(),
      (cliente.microrregiao ?? "").toLowerCase(),
      (cliente.grupoCentralizador ?? "").toLowerCase(),
      (cliente.documento ?? "").toLowerCase(),
      (cliente.codigo ?? "").toLowerCase(),
      (cliente.codigoProspect ?? "").toLowerCase(),
      (cliente.enderecoCompleto ?? "").toLowerCase()

    ].some((str) => normalizeString(str).includes(normalizeString(searchTerm.toLowerCase())));
  };

  const buildBaseCollection = (ordered = true) => {
    let query = ordered ? db.cliente.orderBy("razaoSocial") : db.cliente.toCollection();

    if (vendedorSelecionadoNormalizado) query = query.filter(c => c.usuarioId == vendedorSelecionadoNormalizado);

    if (type === "prospect") query = query.filter(c => c.clienteProspect === 1 && c.ativo);
    else if (type === "recebedor" || type === "optionsConversaoProspect") query = query.filter(c => c.recebedor === 1);
    else if (type === "options" && microrregiao !== 0) query = query.filter(c => c.microrregiaoId === microrregiao);
    else if (type === "options") query = query.filter(c => c.recebedor === 1);
    else if (type === "optionsProspect" || type === "optionsSimulacao") {
      if (type == "optionsSimulacao" && parametros?.length) {
        query = query.filter(opt => (idCliente != null && opt.id == idCliente) || (opt?.trilha?.nome && getBotoesCliente(opt.trilha.nome, "simulador de ensacados")));
      }
      query = query.filter(c => c.recebedor === 1 || c.clienteProspect === 1);
    }
    else if(type === "optionsFunil"){
      query = query.filter(opt => (
        (opt?.codigo && opt?.trilha?.nome ? ["IMO","INFRA"].includes(opt?.trilha?.nome) : false) &&
        opt.recebedor == 1
      ))
    }
    else query = query.filter(c => c.clienteCarteira === 1);

    return query;
  };

  const buildBaseQuery = () => buildBaseCollection(true);

  const applyTipoFilter = (query) => {
    if (!hasFilterValue(filters?.tipo)) {
      return query;
    }

    if (filters.tipo === 1) {
      return query.filter(c => (c.tipo === 1 || c.tipo === 2) && c.clienteProspect === 0);
    }

    if (filters.tipo === 2) {
      return query.filter(c => (c.tipo === 3 || c.tipo === 4) && c.clienteProspect === 0);
    }

    if (filters.tipo === 3) {
      return query.filter(c => c.clienteProspect === 1);
    }

    return query;
  };

  const applyBloqueadoFilter = (query) => {
    if (!hasFilterValue(filters?.bloqueado)) {
      return query;
    }

    return filters.bloqueado
      ? query.filter(c => c.bloqueado === true)
      : query.filter(c => c.bloqueado !== true);
  };

  const applySearchFilter = (query) => {
    if (!searchTerm) {
      return query;
    }

    if (type === "prospect" || type === "optionsProspect") {
      return query.filter(searchProspect);
    }

    if (searchTerm.toLowerCase() === "bloqueado") {
      return query.filter(c => c.bloqueado);
    }

    return query.filter(searchRecebedor);
  };

  const applyQueryFilters = (query) => {
    let filteredQuery = query;

    if (hasFilterValue(filters?.segmentoId)) {
      filteredQuery = filteredQuery.filter(c => c.segmentoId === filters.segmentoId);
    }
    if (hasFilterValue(filters?.trilhaId)) {
      filteredQuery = filteredQuery.filter(c => c.trilhaId === filters.trilhaId);
    }
    if(hasFilterValue(filters?.microrregiao)){
      filteredQuery = filteredQuery.filter(c => c.microrregiaoId === filters.microrregiao);
    }
    if (hasFilterValue(filters?.cidadeId)) {
      filteredQuery = filteredQuery.filter(c => c.endereco?.cidade?.id === filters.cidadeId);
    }
    filteredQuery = applyTipoFilter(filteredQuery);
    filteredQuery = applyBloqueadoFilter(filteredQuery);
    filteredQuery = applySearchFilter(filteredQuery);

    return filteredQuery;
  };

  const applyArrayFilters = (baseClientes = []) => {
    let filteredClientes = baseClientes;

    if (hasFilterValue(filters?.segmentoId)) {
      filteredClientes = filteredClientes.filter((cliente) => cliente.segmentoId === filters.segmentoId);
    }

    if (hasFilterValue(filters?.trilhaId)) {
      filteredClientes = filteredClientes.filter((cliente) => cliente.trilhaId === filters.trilhaId);
    }

    if (hasFilterValue(filters?.microrregiao)) {
      filteredClientes = filteredClientes.filter((cliente) => cliente.microrregiaoId === filters.microrregiao);
    }

    if (hasFilterValue(filters?.cidadeId)) {
      filteredClientes = filteredClientes.filter((cliente) => cliente.endereco?.cidade?.id === filters.cidadeId);
    }

    if (hasFilterValue(filters?.tipo)) {
      if (filters.tipo === 1) {
        filteredClientes = filteredClientes.filter((cliente) => (cliente.tipo === 1 || cliente.tipo === 2) && cliente.clienteProspect === 0);
      } else if (filters.tipo === 2) {
        filteredClientes = filteredClientes.filter((cliente) => (cliente.tipo === 3 || cliente.tipo === 4) && cliente.clienteProspect === 0);
      } else if (filters.tipo === 3) {
        filteredClientes = filteredClientes.filter((cliente) => cliente.clienteProspect === 1);
      }
    }

    if (hasFilterValue(filters?.bloqueado)) {
      filteredClientes = filters.bloqueado
        ? filteredClientes.filter((cliente) => cliente.bloqueado === true)
        : filteredClientes.filter((cliente) => cliente.bloqueado !== true);
    }

    if (searchTerm) {
      if (type === "prospect" || type === "optionsProspect") {
        filteredClientes = filteredClientes.filter(searchProspect);
      } else if (searchTerm.toLowerCase() === "bloqueado") {
        filteredClientes = filteredClientes.filter((cliente) => cliente.bloqueado);
      } else {
        filteredClientes = filteredClientes.filter(searchRecebedor);
      }
    }

    return filteredClientes;
  };

  const clientesTotal = useLiveQuery(() => {
    let query = db.cliente;
    if (type === "prospect" || type === "optionsProspect" || type === "optionsSimulacao")
      query = query
        .where("clienteProspect")
        .equals(1)
        .and((e) => e.ativo);
    else if (type === "recebedor") query = query.where("recebedor").equals(1);
    else if (type === "options") query = query.where("clienteProspect").equals(0);
    else query = query.where("clienteCarteira").equals(1);
    if (searchTerm) {
      if (type === "prospect") query = query.and(searchProspect);
      else if (type === "recebedor") query = query.and(searchRecebedor);
      else if (type === "options") query = query.and(searchRecebedor);
    }

    if (vendedorSelecionadoNormalizado) query = query.filter(c => c.usuarioId == vendedorSelecionadoNormalizado);
    return query.count();
  }, [searchTerm, vendedorSelecionadoNormalizado]);

  const totalClientes = useLiveQuery(() => {
    return db.cliente.count();
  });

  useEffect(() => {
    if (shouldWaitForVendedor) {
      setRemoteBufferedClientes([]);
      setRemotePageSkip(0);
      setClientes([]);
      setTotal(0);
      return;
    }

    if (!shouldUseRemotePagination) {
      setRemoteBufferedClientes([]);
      setRemotePageSkip(0);
      return;
    }

    setRemoteBufferedClientes([]);
    setRemotePageSkip(0);
  }, [shouldUseRemotePagination, vendedorId, shouldWaitForVendedor]);

  const filtrosProntos = type !== "carteira"
    || !enabledRequest
    || (!clientesCarteira.isFetching && typeof clientesCarteira.total !== "number")
    || (typeof totalClientes === "number" && typeof clientesCarteira.total === "number" && totalClientes >= clientesCarteira.total);

  useEffect(() => {
    if (!initialized || !shouldUseRemotePagination || shouldWaitForVendedor) return;

    const paginaAtual = clientesCarteiraPaginada.data || [];

    if (!paginaAtual.length) {
      return;
    }

    setRemoteBufferedClientes((currentClientes) => {
      if (remotePageSkip === 0) {
        return paginaAtual;
      }

      return appendClientes(currentClientes || [], paginaAtual);
    });
  }, [initialized, shouldUseRemotePagination, clientesCarteiraPaginada.data, remotePageSkip, shouldWaitForVendedor]);

  useEffect(() => {
    if (!initialized || !shouldUseRemotePagination || shouldWaitForVendedor) return;

    const totalPaginado = clientesCarteiraPaginada.total ?? clientesCarteira.total ?? 0;
    const visibleCount = skip + take;

    setTotal(totalPaginado);
    setClientes(remoteBufferedClientes.slice(0, visibleCount));

    if (
      visibleCount > remoteBufferedClientes.length &&
      remoteBufferedClientes.length < totalPaginado &&
      !clientesCarteiraPaginada.isFetching
    ) {
      setRemotePageSkip((currentSkip) => currentSkip + remote_scroll_clientes);
    }
  }, [initialized, shouldUseRemotePagination, skip, take, remoteBufferedClientes, clientesCarteiraPaginada.total, clientesCarteira.total, clientesCarteiraPaginada.isFetching, shouldWaitForVendedor]);

  useEffect(() => {
    if (!initialized || shouldWaitForVendedor) return;

    if (shouldUseRemotePagination) {
      return;
    }

    const fetchBuscaCliente = async () => {
      if (type === "carteira" && Array.isArray(todosOsClientes) && todosOsClientes.length > 0) {
        const filteredClientes = hasActiveFilters ? applyArrayFilters(todosOsClientes) : todosOsClientes;
        setTotal(filteredClientes.length);
        setClientes(filteredClientes.slice(0, skip + take));
        markQueryApplied();
        lastQueryStateKeyRef.current = queryStateKey;
        setLoadingSearch(false);
        return;
      }

      if (type === "carteira") {
        const fetchId = activeFetchIdRef.current + 1;
        activeFetchIdRef.current = fetchId;
        let q = db.cliente.where("clienteCarteira").equals(1);
        if (vendedorSelecionadoNormalizado) q = q.filter(c => c.usuarioId == vendedorSelecionadoNormalizado);
        q = await validarProspectsConvertidos(q, { apenasProspects: true });
        const items = await (hasActiveFilters ? applyQueryFilters(q) : q).toArray();
        items.sort((a, b) => (a.razaoSocial || '').localeCompare(b.razaoSocial || ''));
        if (activeFetchIdRef.current !== fetchId) return;
        if (items.length === 0 && lastQueryStateKeyRef.current === queryStateKey) {
          setLoadingSearch(false);
          return;
        }
        setTotal(items.length);
        setClientes(prev => appendClientes(skip === 0 ? [] : prev, items.slice(0, skip + take)));
        markQueryApplied();
        lastQueryStateKeyRef.current = queryStateKey;
        setLoadingSearch(false);
        return;
      }

      if (type === "recebedor") {
        const fetchId = activeFetchIdRef.current + 1;
        activeFetchIdRef.current = fetchId;
        const makeQ = () => {
          let q = db.cliente.where("recebedor").equals(1);
          if (vendedorSelecionadoNormalizado) q = q.filter(c => c.usuarioId == vendedorSelecionadoNormalizado);
          if (searchTerm) q = q.filter(searchRecebedor);
          return q;
        };
        const [items, count] = await Promise.all([
          makeQ().limit(skip + take).toArray(),
          typeof clientesTotal === 'number' ? Promise.resolve(clientesTotal) : makeQ().count()
        ]);
        items.sort((a, b) => (a.razaoSocial || '').localeCompare(b.razaoSocial || ''));
        if (activeFetchIdRef.current !== fetchId) return;
        setTotal(count);
        setClientes(prev => skip === 0 ? items : appendClientes(prev, items));
        markQueryApplied();
        lastQueryStateKeyRef.current = queryStateKey;
        setLoadingSearch(false);
        return;
      }

      const shouldWaitForSkipReset = appliedQueryStateKeyRef.current !== null && appliedQueryStateKeyRef.current !== queryStateKey && skip > 0;

      if (shouldWaitForSkipReset) {
        return;
      }

      const fetchId = activeFetchIdRef.current + 1;
      activeFetchIdRef.current = fetchId;
      const result = [];
      let query = applyQueryFilters(buildBaseQuery());
      const shouldRecalculateTotal = lastQueryStateKeyRef.current !== queryStateKey || skip === 0;

      if (searchTerm) {
        setLoadingSearch(true);
      }

      if (shouldRecalculateTotal) {
        const filteredTotal = await query.count();
        if (activeFetchIdRef.current !== fetchId) {
          return;
        }
        const totalSemFiltro = clientesCarteira.total ?? clientesTotal ?? filteredTotal;
        setTotal(hasActiveFilters ? filteredTotal : totalSemFiltro);
        lastQueryStateKeyRef.current = queryStateKey;
      }

      if (["options", "optionsProspect", "optionsSimulacao", "optionsConversaoProspect", "optionsFunil"].includes(type)) {
        if (take === 0) {
          const allAvailableCustomers = clientesDisponiveis ? query.filter((c) => clientesDisponiveis.includes(c.id)) : query;
          await allAvailableCustomers.each((a) => result.push(a));
        } else {
          const limitedQuery = clientesDisponiveis
            ? query.filter((c) => clientesDisponiveis.includes(c.id)).offset(0).limit(25)
            : query.offset(0).limit(25);

          await limitedQuery.each((a) => result.push(a));
        }

        if (activeFetchIdRef.current !== fetchId) {
          return;
        }

        setClientes(result);
        markQueryApplied();
        setLoadingSearch(false);
        return;
      }

      await query.offset(skip).limit(take).each((a) => result.push(a));

      if (activeFetchIdRef.current !== fetchId) {
        return;
      }

      setClientes((prevClientes) => {
        if (skip === 0) {
          return result;
        }

        return appendClientes(prevClientes || [], result);
      });
      markQueryApplied();
      setLoadingSearch(false);
    };

    fetchBuscaCliente();
  }, [skip, searchTerm, clientesDisponiveis, microrregiao, parametros, filters, vendedorSelecionadoNormalizado, initialized, clientesCarteira.total, clientesTotal, hasActiveFilters, shouldUseRemotePagination, shouldWaitForVendedor, queryStateKey, todosOsClientes, type, take]);

  useEffect(() => {
    if (!initialized || shouldWaitForVendedor) {
      return;
    }

    let active = true;
    const load = async () => {
      let todosClientesValidos;
      if (type === "carteira") {
        let q = db.cliente.where("clienteCarteira").equals(1);
        if (vendedorSelecionadoNormalizado) q = q.filter(c => c.usuarioId == vendedorSelecionadoNormalizado);
        q = await validarProspectsConvertidos(q, { apenasProspects: true });
        todosClientesValidos = await q.toArray();
      } else if (type === "recebedor" || type === "optionsConversaoProspect") {
        let q = db.cliente.where("recebedor").equals(1);
        if (vendedorSelecionadoNormalizado) q = q.filter(c => c.usuarioId == vendedorSelecionadoNormalizado);
        todosClientesValidos = await q.toArray();
      } else if (type === "prospect") {
        let q = db.cliente.where("clienteProspect").equals(1);
        if (vendedorSelecionadoNormalizado) q = q.filter(c => c.usuarioId == vendedorSelecionadoNormalizado);
        todosClientesValidos = (await q.toArray()).filter(c => c.ativo);
      } else {
        todosClientesValidos = await buildBaseCollection(false).toArray();
      }
      todosClientesValidos.sort((a, b) => (a.razaoSocial || '').localeCompare(b.razaoSocial || ''));

      if (active) {
        setTodosOsClientes(todosClientesValidos);
      }
    };
    const subscription = liveQuery(load).subscribe({
      error: (error) => console.error("Erro ao carregar clientes da carteira", error),
    });

    return () => {
      active = false;
      subscription.unsubscribe();
    };
  }, [initialized, type, microrregiao, parametros, vendedorSelecionadoNormalizado, idCliente, totalClientes, shouldWaitForVendedor]);

  function setBulk(data) {
    saveClientesWorker(data);
  }

  const CarteiraIds = async (clientesCarteiraIds) => {
    if (clientesCarteiraIds && !clientesCarteira.isFetching) {
      let ids = (clientesCarteiraIds || []).filter((e) => e.ativo).map((item) => item.id);
      if (ids.length === 0) return;
      const prospectIds = await db.cliente.where("clienteProspect").equals(1).primaryKeys();
      removeClientesWorker([...ids, ...prospectIds]);
    }
  };

  const handleSearch = (inputText) => {
    if (inputText !== searchTerm) {
      setClientes([]);
      setTotal(0);
    }
    setSearchTerm(inputText);
  };

  function onChangeCliente(e) {
    clienteSelect.upDateValue(e.value);
    clienteSelect.upDateDefaultValue(e || "");

    formikRef?.current?.setFieldValue(campo, e.value);
    setTimeout(() => formikRef?.current?.setFieldTouched(campo, true));
  }

  const codigoGeral = (codigoProspect, codigo) => {
    if (codigoProspect != "" && codigoProspect != undefined && codigoProspect != null) return codigoProspect;
    return codigo;
  };

  const options = useMemo(
    () => {
      let optionsData = clientes;

      if (type === "optionsSimulacao") {
        optionsData = optionsData
          ?.map((opt) => {
            return {
              ...opt,
              codigoGeral: codigoGeral(opt?.codigo, opt?.codigoProspect)
            }
          });
      }

      return prepareForOptions((optionsData || []), (type === "optionsProspect") ? arrayOptionsProspect : (type === "optionsSimulacao" ? arrayOptionsSimulador : arrayOptionsCliente), "id");
    }, [clientes]);

  useEffect(() => {
    const syncCarteira = async () => {
      if (shouldWaitForVendedor) {
        return;
      }

      if (!clientesCarteira.data?.length) {
        return;
      }

      if (!shouldUseRemotePagination && !hasActiveFilters && skip === 0) {
        setClientes((currentClientes) => {
          if (currentClientes?.length > 0) {
            return currentClientes;
          }

          return clientesCarteira.data.slice(0, take);
        });
        setTotal((currentTotal) => currentTotal || clientesCarteira.total);
      }

      setBulk(clientesCarteira.data);

      if (skipCarteira + takeCarteira >= clientesCarteira.total || totalClientes >= clientesCarteira.total) {
        CarteiraIds(clientesCarteira.ids);
      }

      if (totalClientes < clientesCarteira.total) {
        setSkipCarteira(skipCarteira + takeCarteira);
        if (takeCarteira === initial_clientes) {
          setTakeCarteira(background_clientes);
        }
        clientesCarteira.clearCache();
      }
    };

    syncCarteira();
  }, [clientesCarteira.data, clientesCarteira.ids, clientesCarteira.total, hasActiveFilters, skip, take, totalClientes, takeCarteira, skipCarteira, shouldWaitForVendedor]);



  return {
    total,
    clientes,
    options,
    searchTerm,
    clienteSelect,
    onChangeCliente,
    todosOsClientes,
    handleSearch,
    loadingCached: false,
    isQueryPending,
    loadingRequest: clientesCarteira.isFetching,
  };
};

export default useClientes;
